import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'
import { PaginationProvider } from '../../providers/PaginationProvider/PaginationProvider'

import { AccessPassesWrapper } from '../../components/AccessPassesWrapper'

export default function AccessPassesPage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <PaginationProvider>
        <AccessPassesWrapper organizationUUID={organization?.uuid} />
      </PaginationProvider>
    </ModalProvider>
  )
}
